import React, { FC } from 'react';
import { View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import { settingsMenuTestIDs, Theme } from '@constants';

import { styles } from './styles';

import { SettingsAccount } from '../SettingsAccount/SettingsAccount';
import { SettingsAlerts } from '../SettingsAlerts/SettingsAlerts';
import { SettingsClosedCaptioning } from '../SettingsClosedCaptioning/SettingsClosedCaptioning';
import { SettingsDebug } from '../SettingsDebug/SettingsDebug';
import { SettingsHelp } from '../SettingsHelp/SettingsHelp';
import { SettingsLocations } from '../SettingsLocations/SettingsLocations';
import { SettingsPrivacyLegal } from '../SettingsPrivacyLegal/SettingsPrivacyLegal';
import { SettingsSignOut } from '../SettingsSignOut/SettingsSignOut';

const { start, end } = Theme.gradients.settingsContent;

const settingsContentMap = {
  [settingsMenuTestIDs.account]: SettingsAccount,
  [settingsMenuTestIDs.locations]: SettingsLocations,
  [settingsMenuTestIDs.alerts]: SettingsAlerts,
  [settingsMenuTestIDs.closedCaptioning]: SettingsClosedCaptioning,
  [settingsMenuTestIDs.help]: SettingsHelp,
  [settingsMenuTestIDs.privacyLegal]: SettingsPrivacyLegal,
  [settingsMenuTestIDs.signOut]: SettingsSignOut,
  [settingsMenuTestIDs.debug]: SettingsDebug,
} as const;

type SettingsContentProps = {
  activeMenuItem: keyof typeof settingsContentMap;
  additionalData?: { enableLocationPanel: boolean } | Record<string, never>;
};

export const SettingsContent: FC<SettingsContentProps> = ({ activeMenuItem, additionalData }) => {
  const ActiveSettingsComponent = settingsContentMap[activeMenuItem] || View;

  return (
    <LinearGradient colors={[start, end]} style={styles.linearGradient}>
      <View style={styles.activeSettingsComponentWrapper}>
        <ActiveSettingsComponent additionalData={additionalData} />
      </View>
    </LinearGradient>
  );
};
